import { Modal, FlexGrid, Heading, Rank, getClassNameFactory } from '@dcl/ui';

import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { Animation } from '@dcl/ui/dist/modules/Modal/ModalConstants';
import React from 'react';
import ErrorBox from '../ErrorBox';
import Holidays from '../Holidays';
import PhoneSupport from '../PhoneSupport';
import { talkWithUsModalMock } from './mocks';
import { ITalkWithUsModalProps } from './TalkWithUsModal.types';
import './TalkWithUsModal.css';

const TalkWithUsModal = (props: ITalkWithUsModalProps): React.ReactElement => {
  const {
    onClose,
    phoneSupportInfo,
    phoneSupportInfoInBrackets,
    countries,
    holidays,
    modalTitle,
  } = props;

  const isPhoneSupport =
    countries ?? phoneSupportInfo ?? phoneSupportInfoInBrackets;

  const isModalData =
    countries ?? phoneSupportInfo ?? phoneSupportInfoInBrackets ?? holidays;

  const getClassName = getClassNameFactory(TalkWithUsModal.displayName);

  return (
    <Modal
      animation={Animation.SLIDEUP}
      closeLabel={'Close'}
      closeThisComponent={onClose}
      className={getClassName()}
      ariaLabel={`${modalTitle} pop up`}
    >
      <FlexGrid>
        <FlexGrid.Row>
          <FlexGrid.Col
            sm={12}
            md={2}
            lg={1}
            className={getClassName({ descendantName: 'icon' })}
          >
            {talkWithUsModalMock.icon}
          </FlexGrid.Col>

          <FlexGrid.Col
            sm={12}
            md={10}
            lg={11}
            className={getClassName({ descendantName: 'header' })}
          >
            <Heading
              type={types.Medium}
              boldType={boldTypes.black}
              rank={Rank.Second}
            >
              <span className={getClassName({ descendantName: 'title' })}>
                {modalTitle}
              </span>
            </Heading>
          </FlexGrid.Col>
        </FlexGrid.Row>
        <FlexGrid.Row>
          <FlexGrid.Col
            sm={12}
            className={getClassName({ descendantName: 'box' })}
          >
            {isModalData ? (
              <>
                {isPhoneSupport && (
                  <PhoneSupport
                    countries={countries}
                    phoneSupportInfo={phoneSupportInfo}
                    phoneSupportInfoInBrackets={phoneSupportInfoInBrackets}
                  />
                )}
                {holidays && <Holidays holidays={holidays} />}
              </>
            ) : (
              <ErrorBox />
            )}
          </FlexGrid.Col>
        </FlexGrid.Row>
      </FlexGrid>
    </Modal>
  );
};

TalkWithUsModal.displayName = 'TalkWithUsModal';
export default TalkWithUsModal;
